// extracted by mini-css-extract-plugin
export default {"defaults":"Overlay_defaults__pmo6+","fadeIn":"Overlay_fadeIn__D94fm","fadeOut":"Overlay_fadeOut__mJnN2"};